export default {
  invoices(state) {
    return state.invoices
  },
  proFormaInvoices(state) {
    return state.proFormaInvoices
  },
  cnDns(state) {
    return state.cnDns
  },
  summary(state) {
    return state.summary
  },
  eInvoiceCount(state) {
    return state.eInvoiceCount
  },
  transactionReport(state) {
    return state.transactionReport
  },
}
